import React, { Fragment } from 'react'
import { Button, } from 'antd'
import { Link, } from 'react-router-dom'
import { ArrowRightOutlined } from '@ant-design/icons';
import './style.css'
export default function MenuCard(props) {
    const { data } = props;
    return (
        <div className='MenuCard'>
            <img className='MenuCard_BackgroundImg' src={data.address} />
            <div className='MenuCard_Background1'></div>
            <div className='MenuCard_Background2'></div>
            <div className='MenuCard_Main'>
                <div className='MenuCard_MainTitle'>{data.title}</div>
                <div className='MenuCard_MainTitleBottom' />
                <div className='MenuCard_MainIntroduce'>{data.introduce}</div>
                <Link to={{ pathname: data.location, state: { index: data.index } }}>
                    {/* <Button className='MenuCard_MainButton' onClick={() => props.menuCardJump(data.loction)}> */}
                    <Button className='MenuCard_MainButton' onClick={() => props.menuCardJump(data.loction)}>
                        <div className='MenuCard_MainButtonText'>{data.buttonText}</div>
                        <ArrowRightOutlined className='MenuCard_MainButtonIcon' />
                    </Button>
                </Link>
            </div>
        </div>
    )
}